var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmallScreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1814 0H2.89C1.28714 0 0 1.28714 0 2.86571V14.0371C0 15.6157 1.28714 16.9271 2.89 16.9271H20.2057C21.7843 16.9271 23.0957 15.64 23.0957 14.0371V2.86571C23.0714 1.28714 21.7843 0 20.1814 0ZM21.76 14.0371C21.76 14.8871 21.0557 15.5914 20.2057 15.5914H2.89C2.04 15.5914 1.33571 14.8871 1.33571 14.0371V2.86571C1.33571 2.01571 2.04 1.31143 2.89 1.31143H20.2057C21.0557 1.31143 21.76 2.01571 21.76 2.86571V14.0371Z",
    fill: "#74B44A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4769 7.38281H11.5112C11.1469 7.38281 10.8555 7.67424 10.8555 8.03853V13.3085C10.8555 13.6728 11.1469 13.9642 11.5112 13.9642H19.4769C19.8412 13.9642 20.1326 13.6728 20.1326 13.3085V8.03853C20.1326 7.67424 19.8412 7.38281 19.4769 7.38281ZM18.7969 12.6528H12.1669V8.69424H18.7969V12.6528Z",
    fill: "#74B44A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallScreen);
export default __webpack_public_path__ + "static/media/small-screen.07c10b76c53db1421821417393aedf11.svg";
export { ForwardRef as ReactComponent };